<template>
  <v-dialog v-model="mainStore.atlantic27InscriptionGate.showDialog" width="500" max-width="100%" scroll-strategy="none"
    persistent>
    <v-card>

      <v-card-text>
        <div class="d-flex flex-row justify-space-between align-center gap-2">
          <div class="text-h6 font-weight-bold">Restrictions</div>
          <v-icon icon="mdi-close" size="24" @click="close"></v-icon>
        </div>

        <p class="mb-4">
          Merci de renseigner votre code postal pour continuer votre inscription.
          Les inscriptions sont réservées aux habitants de Loire-Atlantique (44) jusqu'au 30 septembre 2026.
        </p>
        <div class="d-flex flex-row justify-space-between align-center gap">
          <v-text-field v-model="codePostal" label="Code postal" maxlength="5" inputmode="numeric"
            :error-messages="errorMessage" @keyup.enter="submit" autofocus hide-details />
          <v-btn color="darkblue" variant="elevated" elevation="0" @click="submit">
            Continuer
          </v-btn>
        </div>

        <v-divider class="my-4"></v-divider>
        <div class="mb-2">
          <div class="font-weight-bold">OFFRE 50 MILES • DU 18 AU 30 SEPTEMBRE 2026</div>
          <p>Votre dossard MaXi-Race est garanti !<br>
            Vous souhaitez participer au 50 Miles de l’Atlantic’Trail 2027 et bénéficier d’un dossard garanti pour
            l’adidas MaXi-Race ?<br>
            Bonne nouvelle : l’offre est toujours disponible
          </p>
        </div>
        <v-btn color="darkblue" variant="text" block @click="selectMaxirace">
          M'inscrire
        </v-btn>


      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  data() {
    return {
      codePostal: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
    errorMessage() {
      if (this.mainStore.atlantic27InscriptionGate.showRejectedMessage) {
        return "Les inscriptions sont réservées aux habitants de Loire-Atlantique (44) jusqu'au 30 septembre 2026.";
      }
      return "";
    },
  },
  watch: {
    "mainStore.atlantic27InscriptionGate.showDialog"(isOpen) {
      if (isOpen) {
        this.codePostal = "";
      }
    },
  },
  methods: {
    submit() {
      this.mainStore.confirmAtlantic27CodePostal(this.codePostal);
    },
    selectMaxirace() {
      this.mainStore.confirmAtlantic27Maxirace();
    },
    close() {
      this.mainStore.closeAtlantic27InscriptionDialog();
    },
  },
};
</script>
